import React from 'react';
import { Snackbar, useTheme, Portal } from '@mui/material';

import { SNACKBAR_AUTO_HIDE_DURATION } from '@assetron/common/constants/constant';
import useIsMobile from '../../hooks/useIsMobile';
import AssetronAlert from './AssetronAlert';

export interface CommonSnackbarProps {
  open: boolean;
  onClose: () => void;
  message: string;
  type: 'success' | 'warning' | 'error';
  autoHideDuration?: number;
}

function CommonSnackbar({
  open,
  onClose,
  message,
  type,
  autoHideDuration = SNACKBAR_AUTO_HIDE_DURATION,
}: Readonly<CommonSnackbarProps>) {
  const theme = useTheme();
  const isSmallScreen = useIsMobile();

  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          paddingTop: isSmallScreen ? '36px' : 'auto',
          zIndex: theme.zIndex.modal + 1,
        }}
        data-testid={`toaster-${type}`}
      >
        <div>
          <AssetronAlert message={message} type={type} />
        </div>
      </Snackbar>
    </Portal>
  );
}

export default CommonSnackbar;
